// extracted by mini-css-extract-plugin
export default {"faq":"delivery-faq_faq__4rUJg"};